import React from 'react';

import './css/cateringViewSwitch.css';

const CateringViewSwitch = ({ activeSection, onChange, disabled = false }) => (
    <div className="catering-view-switch" role="tablist" aria-label="Catering orders or quotes">
        <button
            type="button"
            role="tab"
            aria-selected={activeSection === 'orders'}
            disabled={disabled}
            className={`catering-view-switch__segment${
                activeSection === 'orders' ? ' catering-view-switch__segment--active' : ''
            }`}
            onClick={() => onChange('orders')}
        >
            Orders
        </button>
        <button
            type="button"
            role="tab"
            aria-selected={activeSection === 'quotes'}
            disabled={disabled}
            className={`catering-view-switch__segment${
                activeSection === 'quotes' ? ' catering-view-switch__segment--active' : ''
            }`}
            onClick={() => onChange('quotes')}
        >
            Quotes
        </button>
    </div>
);

export default CateringViewSwitch;
